export default __webpack_public_path__ + "static/media/auth-decoration.62d5fe1b.png";